import { useTranslation } from 'react-i18next';
const SuccessToast = () => {
  const [t] = useTranslation();
  return t('CART_SUCCESS_TOAST');
};

export default SuccessToast;
